import React from "react";
import "./Services.css";

// Importing icons
import {
  FaCartFlatbedSuitcase,
  FaCartShopping,
  FaRupeeSign,
  FaTruckFast,
} from "react-icons/fa6";
import { RiShieldCheckLine } from "react-icons/ri";
import { MdAttachMoney, MdStorefront } from "react-icons/md";
import { GiWheat } from "react-icons/gi";
import { useTranslation } from "react-i18next";

// Define component
const Services: React.FC = () => {

  const { t, i18n } = useTranslation()



  return (
    <>
      <div className="servicesWrapper">
        <div className="servicesGrid">
          <div className="serviceBox">
            <div className="serviceBoxTop">
              <FaCartFlatbedSuitcase />
              <h3>{t('section.Free Shipping')}</h3>
            </div>
            <p>{t('content.Free Shipping')}</p>
          </div>

          <div className="serviceBox">
            <div className="serviceBoxTop">
              <RiShieldCheckLine />
              <h3>{t('section.Easy Payment')}</h3>
            </div>
            <p>{t('content.Easy Payment')}</p>
          </div>

          <div className="serviceBox">
            <div className="serviceBoxTop">
              <FaTruckFast />
              <h3>{t('section.Everyday Shipping')}</h3>
            </div>
            <p>{t('content.Everyday Shipping')}</p>
          </div>

          <div className="serviceBox">
            <div className="serviceBoxTop">
              <GiWheat />
              <h3>{t('section.Chemical Free Products')}</h3>
            </div>
            <p>{t('content.Chemical Free Products')}</p>
          </div>

          <div className="serviceBox">
            <div className="serviceBoxTop">
              <RiShieldCheckLine />
              <h3>{t('section.Pick-up Available')}</h3>
            </div>
            <p>{t('content.Pick-up Available')}</p>
          </div>

          <div className="serviceBox">
            <div className="serviceBoxTop">
              <MdAttachMoney />
              <h3>{t('section.Sodexo Payment')}</h3>
            </div>
            <p>{t('content.Sodexo Payment')}</p>
          </div>

          <div className="serviceBox">
            <div className="serviceBoxTop">
              <FaCartShopping />
              <h3>{t('section.B2B Online Store')}</h3>
            </div>
            <p>{t('content.B2B Online Store')}</p>
          </div>

          <div className="serviceBox">
            <div className="serviceBoxTop">
              <MdStorefront />
              <h3>{t('section.Large Variety')}</h3>
            </div>
            <p>{t('content.Large Variety')}</p>
          </div>
        </div>
      </div>


      <div style={{ textAlign: "left", marginLeft: '30px' }}>
        <p>{t("intro.line1")}</p>
        <p>{t("intro.line2")}</p>
        <p>{t("intro.line3")}</p>
      </div>
    </>
  );
};

export default Services;
